export interface ICaptureConfig {
    name: string,
    captureConfigUUID?: string,
    sourceType: string,
    sourceParams: {
        location: string, 
        secretPath: string,
        paths: IPath[],
    },
    durationMinutes: number,
    durationMessages: number,
    delayMinutes: number,
    TTL: number, // days
    status?: string,
}

interface IPath {
    url: string
}

export interface IGetCaptureConfigsResponse {
    data: ICaptureConfig[],
}

export interface IPostCaptureConfigResponse {
    data: ICaptureConfigUUIDResponse,
}

export interface IPutCaptureConfigResponse {
    data: ICaptureConfigUUIDResponse,
}

export interface ICaptureConfigUUIDResponse {
    captureConfigUUID: string,
}

export const DefaultCaptureConfig: ICaptureConfig = {
    name: "",
    sourceType: "mqtt",
    sourceParams: {
        location: "",
        secretPath: "",
        paths: [{url: ""}],
    },
    durationMinutes: 10,
    durationMessages: 0,
    delayMinutes: 5,
    TTL: 30,
}